module.exports = __webpack_public_path__ + "static/media/Paramonga_256x256px.2130d32c.jpg";